import { useCallback } from "react";
import { IAudioHandles } from "providers/AudioProvider/handleTypes";
import { ILang, MetadataToSubtitlesLanguages } from "providers/AudioProvider/types";
import { IVoiceType } from "types";

interface IUseAudio {
    handles: IAudioHandles;
    subtitleId: string | null;
    lang: ILang;
    folder: number;
    mediaId: string;
    useCheckedVoiceoverSynthesis: boolean;
}

export const useAudio = ({
    handles,
    subtitleId,
    lang,
    folder,
    mediaId,
    useCheckedVoiceoverSynthesis,
}: IUseAudio) => {
    const deleteAudio = useCallback(async () => {
        if (!subtitleId) {
            return null;
        }
        return await handles.deleteAudio({
            lang: MetadataToSubtitlesLanguages[lang],
            id: subtitleId,
        });
    }, [handles, subtitleId, lang]);

    const saveAudio = useCallback(async (voice: IVoiceType, speed: number, synt_audio_type?: "tts" | "original_ru") => {
        if (!subtitleId) {
            return;
        }

        if (useCheckedVoiceoverSynthesis && synt_audio_type !== "original_ru") {
            return await handles.audioSynthesizeWithCheck({
                lang: MetadataToSubtitlesLanguages[lang],
                trackId: subtitleId,
                folder,
                mediaId,
                voice,
                speed,
                // ♪ самой реплики: снятая с озвучки (⊘) реплика возвращается и озвучивается.
                unskip: true,
            });
        }

        return await handles.audioSynthesize({
            lang: MetadataToSubtitlesLanguages[lang],
            trackId: subtitleId,
            folder,
            mediaId,
            voice,
            speed,
            synt_audio_type,
            unskip: synt_audio_type !== "original_ru",
            // ♪ строки переозвучивает голосом самой строки — человек голос не выбирал (проба P50m10d).
            voiceNamed: false,
        });
    }, [folder, handles, lang, mediaId, subtitleId, useCheckedVoiceoverSynthesis]);

    return { deleteAudio, saveAudio };
};
